/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: Z8Sy7rP6ZFXR
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicButtonTab.module.css"; // plasmic-import: Z8Sy7rP6ZFXR/css
import Workspace1024PxIcon from "./icons/PlasmicIcon__Workspace1024Px"; // plasmic-import: pwj1vvvDK2dP/icon

createPlasmicElementProxy;

export const PlasmicButtonTab__VariantProps = new Array("type");

export const PlasmicButtonTab__ArgProps = new Array("iconTab", "onClick");

const $$ = {};

function PlasmicButtonTab__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "type",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.type
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"tabButton"}
      data-plasmic-override={overrides.tabButton}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.tabButton,
        {
          [sty.tabButtontype__default]: hasVariant($state, "type", "_default"),
          [sty.tabButtontype_withLine]: hasVariant($state, "type", "withLine")
        }
      )}
    >
      <button
        data-plasmic-name={"tabButton2"}
        data-plasmic-override={overrides.tabButton2}
        className={classNames(
          projectcss.all,
          projectcss.button,
          sty.tabButton2
        )}
        onClick={async event => {
          const $steps = {};
          $steps["runOnClick"] = true
            ? (() => {
                const actionArgs = { eventRef: $props["onClick"] };
                return (({ eventRef, args }) => {
                  return eventRef?.(...(args ?? []));
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["runOnClick"] != null &&
            typeof $steps["runOnClick"] === "object" &&
            typeof $steps["runOnClick"].then === "function"
          ) {
            $steps["runOnClick"] = await $steps["runOnClick"];
          }
        }}
        ref={ref => {
          $refs["tabButton2"] = ref;
        }}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <Workspace1024PxIcon
              className={classNames(projectcss.all, sty.svg__tP6Rr)}
              role={"img"}
            />
          ),

          value: args.iconTab
        })}
      </button>
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxtype_withLine]: hasVariant($state, "type", "withLine")
        })}
      />
    </div>
  );
}

const PlasmicDescendants = {
  tabButton: ["tabButton", "tabButton2", "freeBox"],
  tabButton2: ["tabButton2"],
  freeBox: ["freeBox"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicButtonTab__ArgProps,
          internalVariantPropNames: PlasmicButtonTab__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicButtonTab__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "tabButton") {
    func.displayName = "PlasmicButtonTab";
  } else {
    func.displayName = `PlasmicButtonTab.${nodeName}`;
  }
  return func;
}

export const PlasmicButtonTab = Object.assign(
  // Top-level PlasmicButtonTab renders the root element
  makeNodeComponent("tabButton"),
  {
    // Helper components rendering sub-elements
    tabButton2: makeNodeComponent("tabButton2"),
    freeBox: makeNodeComponent("freeBox"),
    // Metadata about props expected for PlasmicButtonTab
    internalVariantProps: PlasmicButtonTab__VariantProps,
    internalArgProps: PlasmicButtonTab__ArgProps
  }
);

export default PlasmicButtonTab;
/* prettier-ignore-end */
